import {
  PersistedFormGroup,
  PersistedFormArray,
  PersistedArray,
} from './persisted-form-group';
import type {
  PersistedFormGroupOptions,
  PersistedFormArrayOptions,
  PersistedArrayOptions,
} from './persisted-form-group';
import type { SchemaFormControl } from '@apexdesigner/schema-forms';
import { OrganizationPropertyValue } from './organization-property-value';
export { OrganizationPropertyValue };
import { organizationPropertyValueSchema } from '@schemas/business-objects/organization-property-value';
import { OrganizationFormGroup } from './organization-form-group';
import { OrganizationPropertyFormGroup } from './organization-property-form-group';

export class OrganizationPropertyValueFormGroup extends PersistedFormGroup {
  declare controls: {
    id: SchemaFormControl;
    textValue: SchemaFormControl;
    numberValue: SchemaFormControl;
    organizationId: SchemaFormControl;
    organization: OrganizationFormGroup;
    organizationPropertyId: SchemaFormControl;
    organizationProperty: OrganizationPropertyFormGroup;
  };

  declare value: Partial<OrganizationPropertyValue>;

  constructor(
    data?: Record<string, any> | null,
    options?: PersistedFormGroupOptions,
  ) {
    super(
      organizationPropertyValueSchema,
      OrganizationPropertyValue,
      data,
      options,
    );
  }

  get object(): OrganizationPropertyValue {
    return new OrganizationPropertyValue(this.getRawValue());
  }

  protected override createControl(name: string) {
    switch (name) {
      case 'organization':
        return new OrganizationFormGroup();
      case 'organizationProperty':
        return new OrganizationPropertyFormGroup();
      default:
        return undefined;
    }
  }

  static async find(filter?: any): Promise<OrganizationPropertyValue[]> {
    return OrganizationPropertyValue.find(filter);
  }

  static async findOne(
    filter?: any,
  ): Promise<OrganizationPropertyValue | null> {
    return OrganizationPropertyValue.findOne(filter);
  }

  static async findById(
    id: number,
    filter?: any,
  ): Promise<OrganizationPropertyValue> {
    return OrganizationPropertyValue.findById(id, filter);
  }

  static async create(
    data: Partial<OrganizationPropertyValue>,
  ): Promise<OrganizationPropertyValue> {
    return OrganizationPropertyValue.create(data as any);
  }

  static async updateById(
    id: number,
    updates: Partial<OrganizationPropertyValue>,
  ): Promise<OrganizationPropertyValue> {
    return OrganizationPropertyValue.updateById(id, updates as any);
  }

  static async deleteById(id: number): Promise<boolean> {
    return OrganizationPropertyValue.deleteById(id);
  }
}

export class OrganizationPropertyValueFormArray extends PersistedFormArray {
  readonly entityName = 'OrganizationPropertyValue' as const;

  constructor(options?: PersistedFormArrayOptions) {
    super(organizationPropertyValueSchema, OrganizationPropertyValue, options);
  }

  protected override createItemGroup() {
    return new OrganizationPropertyValueFormGroup();
  }

  get array(): OrganizationPropertyValue[] {
    return this.controls.map(
      (group: OrganizationPropertyValueFormGroup) => group.object,
    );
  }
}

export class OrganizationPropertyValuePersistedArray extends PersistedArray<OrganizationPropertyValue> {
  readonly entityName = 'OrganizationPropertyValue' as const;

  constructor(options?: PersistedArrayOptions) {
    super(OrganizationPropertyValue, options);
  }
}
